/**
 * Safe utility functions for null/undefined protection.
 * Import these instead of using raw Object.entries/values/keys or array access.
 */

/**
 * Safe Object.entries — returns [] if input is null/undefined
 * @example safeEntries(data?.projectHealth).map(([key, val]) => ...)
 */
export const safeEntries = (obj) => Object.entries(obj || {})

/**
 * Safe Object.values — returns [] if input is null/undefined
 * @example safeValues(data?.tokens).reduce((a, b) => a + b, 0)
 */
export const safeValues = (obj) => Object.values(obj || {})

/**
 * Safe Object.keys — returns [] if input is null/undefined
 * @example safeKeys(data?.config).forEach(k => ...)
 */
export const safeKeys = (obj) => Object.keys(obj || {})

/**
 * Safe array access — returns [] if input is null/undefined/non-array
 * @example safeArray(data?.items).map(item => ...)
 */
export const safeArray = (arr) => (Array.isArray(arr) ? arr : [])

/**
 * Safe deep property access with default value
 * @example safeGet(data, 'resourceAllocation.agents.active', 0)
 */
export const safeGet = (obj, path, defaultValue = undefined) => {
  try {
    return path.split('.').reduce((o, k) => (o ?? {})[k], obj) ?? defaultValue
  } catch {
    return defaultValue
  }
}
